/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";
import { AlertNotificationDTO } from '@well/domain';

@Injectable({
  providedIn: 'root'
})
export class AlertNotificationResourceService extends AbstractResourceService<any, AlertNotificationDTO, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('alertNotificationUrl'),
      undefined,
      AlertNotificationDTO
    );
  }

  solve(uuid: string): Observable<boolean> {
    return <Observable<boolean>>this.httpClient?.put(`${this.url}/${uuid}/solve`, null);
  }

  ignore(uuid: string): Observable<boolean> {
    return <Observable<boolean>>this.httpClient?.put(`${this.url}/${uuid}/ignore`, null);
  }
}
